import PIETab from '@src/shared/components/PIETab';
import { PIETabItem } from '@src/shared/components/PIETabItem';
import React from 'react';
import { TAB_SELECTION } from '../CourierListMobile';
import PIEText from '@src/shared/components/PIEText';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import { Trans } from 'react-i18next';
import styles from './CourierListTabMenu.module.scss';
interface componentProps {
  tabSelectionValue: TAB_SELECTION;
  onTabSelect: (selectedTab: TAB_SELECTION) => void;
}

const CourierListTabMenu = ({ tabSelectionValue, onTabSelect }: componentProps) => {
  const { isResolutionMobile } = useDeviceDetect();
  return (
    <div className={styles.manageCouriersTabIndicator}>
      <PIETab>
        <PIETabItem
          id="active-couriers-tab"
          isSelected={tabSelectionValue === TAB_SELECTION.ACTIVE}
          onClick={() => onTabSelect(TAB_SELECTION.ACTIVE)}
          aria={{ controls: 'active-couriers-panel' }}
        >
          <PIEText
            align={isResolutionMobile ? 'center' : 'left'}
            text={<Trans i18nKey="manage_couriers.TAB_TITLE_ACTIVE" />}
            size={'var(--xds-font-size-16)'}
            fontWeight="var(--xds-font-weight-bold)"
          />
        </PIETabItem>
        <PIETabItem
          id="pending-couriers-tab"
          isSelected={tabSelectionValue === TAB_SELECTION.PENDING}
          onClick={() => onTabSelect(TAB_SELECTION.PENDING)}
          aria={{ controls: 'pending-couriers-panel' }}
        >
          <PIEText
            align={isResolutionMobile ? 'center' : 'left'}
            text={<Trans i18nKey="manage_couriers.TAB_TITLE_PENDING" />}
            size={'var(--xds-font-size-16)'}
            fontWeight="var(--xds-font-weight-bold)"
          />
        </PIETabItem>
      </PIETab>
    </div>
  );
};

export default CourierListTabMenu;
